export type FlightEventData = {
  destination_point: string;
  starting_point: string;
  arrival_date: string;
  departure_date: string;
  is_one_way: string;
  is_direct: string;
};

export const flight_ga4Event = (flightData: FlightEventData) => {
  const formatDate = (dateString: string) => {
    const [year, month, day] = dateString.split('-');
    return `${day}.${month}.${year}`;
  };

  const formattedFlightData = {
    ...flightData,
    arrival_date: formatDate(flightData.arrival_date),
    departure_date: formatDate(flightData.departure_date),
  };

  dataLayer.push({
    event: 'ga4Event',
    event_name: 'flight_configurator',
    ...formattedFlightData,
  });
};
